/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseWarnings
 */
export interface GetPaymentRequestEvidence200ResponseWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum = typeof GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum];
export const GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum = typeof GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum];
export const GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum = typeof GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum];


